import React from 'react';
import { SearchResultsLayout } from './Common/SearchResultsLayout/SearchResultsLayout';

export const SearchResults = () => {
  return <SearchResultsLayout />;
};
